import AllowancesCalculator from './allowances-calculator';
import UmbrellaEmployerNationalInsuranceCalculator from './umbrella-employer-national-insurance-calculator';
import NationalInsuranceCalculator from './national-insurance-calculator';
import PensionContribCalculator from './pension-contribution-calculator';
import StudentLoanCalculator from './student-loan-calculator';
import TaxCalculator from './tax-calculator';
import Salary from '../salary';

export default class UmbrellaNetIncomeCalculator {
    constructor(umbrellaFee, taxYear) {
        this.umbrellaFee = umbrellaFee;
        this.taxYear = taxYear;
    }

    calculate(employee, salary) {

        console.log('Gross: ', salary.getGross('year') / 52);

        const salaryMinusCompanyDeductions = new Salary({
            salary: salary.getGross('year') - this.umbrellaFee - salary.annualExpense,
            employee: employee,
            frequency: 'year',
            annualExpense: salary.annualExpense
        });

        console.log('Gross after co deductions: ', salaryMinusCompanyDeductions.getGross("year") / 52);

        const employerNiCalculator = new UmbrellaEmployerNationalInsuranceCalculator(
            employee,
            salaryMinusCompanyDeductions,
            this.taxYear.employerNationalInsurance
        );

        console.log('Employer NI: ', employerNiCalculator.calculate() / 52);
        console.log('Company margin: ', this.umbrellaFee / 52);
        console.log('Expense: ', salary.annualExpense / 52);

        const contractorSalary = new Salary({
            salary: salaryMinusCompanyDeductions.getGross('year') - employerNiCalculator.calculate(),
            employee: employee,
            frequency: 'year',
            annualExpense: salary.annualExpense
        });

        console.log('Contractor gross: ', contractorSalary.getGross('week'));

        const allowancesCalculator = new AllowancesCalculator(employee, contractorSalary, this.taxYear.allowances);

        const nationalInsuranceCalculator = new NationalInsuranceCalculator(employee, contractorSalary, this.taxYear.nationalInsurance);
        const pensionContribCalculator = new PensionContribCalculator(employee, contractorSalary);
        const studentLoanCalculator = new StudentLoanCalculator(employee, contractorSalary, this.taxYear.studentLoan);
        const taxCalculator = new TaxCalculator(allowancesCalculator, contractorSalary, this.taxYear.taxBands);

        const grossIncome = contractorSalary.getGross('year');
        const tax = taxCalculator.calculate();
        const ni = nationalInsuranceCalculator.calculate();
        const studentLoan = studentLoanCalculator.calculate();
        const pensionContrib = pensionContribCalculator.calculate();

        console.log('Contractor NI: ', ni / 52);
        console.log('Contractor Tax: ', tax / 52);

        const deductions = tax + ni + studentLoan + pensionContrib;

        return (grossIncome - deductions) + salary.annualExpense;
    }
}